export default "__VITE_ASSET__BGJBDzmx__"